import { render, staticRenderFns } from "./SingleSystemQuizView.vue?vue&type=template&id=047df5a2&scoped=true&"
import script from "./SingleSystemQuizView.vue?vue&type=script&lang=js&"
export * from "./SingleSystemQuizView.vue?vue&type=script&lang=js&"
import style0 from "./SingleSystemQuizView.vue?vue&type=style&index=0&id=047df5a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047df5a2",
  null
  
)

export default component.exports